import React, { useState } from "react";

const fmt = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(n) || 0);
const STILE = {
  buono: { label: "Buono", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  attenzione: { label: "Attenzione", cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  basso: { label: "Basso", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

const Row = ({ l, v, cls = "" }) => <div className={`flex justify-between gap-2 ${cls}`}><span className="min-w-0">{l}</span><span className="whitespace-nowrap">{v}</span></div>;

// Venditore semplice: solo colore + giudizio. Admin / Area Manager: % esatta e dettaglio costi.
export default function MargineBox({ m, details, breakdown, testId = "margine-box" }) {
  const [open, setOpen] = useState(false);
  if (!m) return null;
  const s = STILE[m.giudizio];
  return (
    <div className="mb-3" data-testid={testId}>
      <button type="button" onClick={() => details && setOpen(!open)}
        className={`w-full text-[11px] font-bold flex items-center justify-between px-2.5 py-1.5 rounded border ${s.cls} ${details ? "cursor-pointer" : "cursor-default"}`}
        data-testid={`${testId}-toggle`}>
        <span className="flex items-center gap-1.5"><span className={`h-2 w-2 rounded-full ${s.dot}`} />Margine</span>
        <span data-testid={`${testId}-valore`}>{details ? `${m.pct.toFixed(1)}% · ${s.label}` : s.label}{details && (open ? " ▾" : " ▸")}</span>
      </button>
      {details && open && (
        <div className="bg-zinc-50 border border-zinc-200 rounded p-2.5 mt-1 space-y-1 mono text-[11px]" data-testid={`${testId}-dettaglio`}>
          <Row l="Prezzo di vendita (IVA escl.)" v={fmt(m.ricavo)} cls="text-emerald-700" />
          <Row l="− Costi diretti" v={`− ${fmt(m.costiDiretti)}`} cls="text-rose-700" />
          {(breakdown || []).filter((b) => b.importo > 0).map((b) => (
            <Row key={b.nome} l={`   · ${b.nome}${b.stimato ? " (stimato)" : ""}`} v={fmt(b.importo)} cls={`text-[10px] ${b.stimato ? "text-amber-700" : "text-zinc-500"}`} />
          ))}
          {m.fissi.map((c) => <Row key={c.nome} l={`− ${c.nome} ${c.label}`} v={`− ${fmt(c.importo)}`} cls="text-zinc-600" />)}
          <Row l={`− Provvigione venditore (${m.provPct}%)`} v={`− ${fmt(m.provvigione)}`} cls="text-amber-700" />
          <Row l="= Utile" v={fmt(m.utile)} cls={`font-bold text-sm border-t border-zinc-300 pt-1 ${m.giudizio === "basso" ? "text-rose-700" : "text-emerald-700"}`} />
          <div className="text-[10px] text-zinc-500">Margine {m.pct.toFixed(1)}% · minimo {m.soglia}% (sotto serve autorizzazione per gli sconti)</div>
        </div>
      )}
    </div>
  );
}
